import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataTable, DeleteModal } from "CommonComponent";
import UserFilter from "./components/UserFilter/UserFilter";
import { fetchBoundUsers, unbindUsersFromProgram } from "actions";
import AccessRights from "utils/AccessRights";
import { OverlayTrigger, Tooltip } from "react-bootstrap";


const UserViewTab = ({
  programId,
  userExtraFiltersState,
  setUserExtraFiltersState,
}) => {
  const dispatch = useDispatch();
  const [showDelete, setShowDelete] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const { bound_users, isUsersLoading } = useSelector(
    (state) => state.programSetupState,
  );
  const session = useSelector((s) => s.session);

  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  useEffect(() => {
    if (programId) {
      dispatch(fetchBoundUsers(programId, { object_viewed_id }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programId]);

  const handleShowDelete = (user) => {
    setSelectedUser(user);
    setShowDelete(true);
  };

  const handleCloseDelete = () => {
    setShowDelete(false);
    setSelectedUser(null);
  };

  const handleRemove = () => {
    if (selectedUser) {
      let data = {
        program_id: programId,
        user_ids: [selectedUser.id],
        object_viewed_id,
        ...userExtraFiltersState.values,
      };
      dispatch(unbindUsersFromProgram(data));
      handleCloseDelete();
    }
  };

  const getActions = (row) => (
    <div className="d-flex align-items-center gap-2">
      {AccessRights(
        session.current_page_permissions,
        "delete",
        row.created_by,
      ) &&
        row.is_deleted === "n" && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-unbind-${row.id}`}>Unbind The User</Tooltip>}
          >
            <img
              src="/assets/images/detach-btn-icon.svg"
              alt="Unbind"
              style={{ cursor: "pointer" }}
              onClick={() => handleShowDelete(row)}
            />
          </OverlayTrigger>
        )}
    </div>
  );

  const Columns = () => [
    {
      id: "full_name",
      header: "Full Name",
      accessor: (row) => row.user?.name || "N/A",
      sortable: true,
      searchable: true,
    },
    {
      id: "email",
      header: "Email",
      accessor: (row) => row.user?.email || "N/A",
      sortable: true,
      searchable: true,
    },
    {
      id: "user_type",
      header: "User Type",
      accessor: (row) => row.user?.user_type?.name || "N/A",
      sortable: true,
      searchable: true,
    },
    {
      id: "actions",
      header: "Action",
      accessor: (row) => getActions(row),
      sortable: false,
      searchable: false,
    },
  ];

  return (
    <div>
      <UserFilter
        userExtraFiltersState={userExtraFiltersState}
        setUserExtraFiltersState={setUserExtraFiltersState}
        object_viewed_id={object_viewed_id}
        programId={programId}
      />
      <DataTable
        columns={Columns({ getActions })}
        data={bound_users || []}
        serverSide={false}
        showSearch={false}
        isLoading={isUsersLoading}
        className="table-container"
      />
      <DeleteModal
        show={showDelete}
        onClose={handleCloseDelete}
        onDelete={handleRemove}
        deleteBtnTxt="Unbind"
        message="Are you sure you want to unbind this user?"
      />
    </div>
  );
};

export default UserViewTab;
